import { cloneElement, ReactElement, useState } from 'react';

import { UpsertLocation } from 'contacts/components';
import { ContactGroupType } from 'contacts/enums';
import { IContactGroupAddress } from 'contacts/types';

interface IProps {
  location?: IContactGroupAddress;
  contactGroupType: ContactGroupType;
  buttonElement?: ReactElement;
  onSubmitSuccess?: (address?: IContactGroupAddress) => void;
}

export const EditLocationButton = ({
  location,
  contactGroupType,
  buttonElement,
  onSubmitSuccess,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnClose = () => {
    setIsOpen(false);
  };

  const button = buttonElement
    ? cloneElement(buttonElement, { onClick: () => setIsOpen(true) })
    : null;

  return (
    <>
      {button}

      <UpsertLocation
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmitSuccess={onSubmitSuccess}
        location={location}
        contactGroup={location?.contactGroup}
        contactGroupType={contactGroupType}
      />
    </>
  );
};
